import { getCreateWorkflowBindleAuthorizationRequest } from 'src/authentication/bindle-utils';
import { useBindleAuthorization } from 'src/hooks/useBindleAuthorization';
import { stage } from 'src/config';

interface UseWorkflowCreatePermissionResult {
	hasCreatePermission: boolean;
	isCheckingCreatePermission: boolean;
}

/**
 * Custom hook that checks whether the current user has permission to create workflows.
 * Verifies "Can Manage" on the OLAF SoftwareApp bindle (stage-aware).
 *
 * @param userName - The authenticated user's login name
 */
export function useWorkflowCreatePermission(
	userName: string | undefined
): UseWorkflowCreatePermissionResult {
	const { isAuthorized, isCheckingPermission } =
		useBindleAuthorization(
			userName,
			getCreateWorkflowBindleAuthorizationRequest(stage)
		);

	return {
		hasCreatePermission: isAuthorized,
		isCheckingCreatePermission: isCheckingPermission,
	};
}
